type Props = { fill?: string };

const ReportIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M14 13.5C14.552 13.5 15 13.948 15 14.5C15 15.052 14.552 15.5 14 15.5H1C0.448 15.5 0 15.052 0 14.5C0 13.948 0.448 13.5 1 13.5H14ZM4 11.5H1V5.5H4V11.5ZM9 11.5H6V1.5H9V11.5ZM14 7.5V11.5H11V7.5H14Z"
        fill="#3B3F42"
      />
    </svg>
  );
};

export default ReportIcon;
